<template>
  <page-header-wrapper>
    <a-card :bordered='false'>
      <!-- 条件搜索 -->
      <div class='table-page-search-wrapper'>
        <a-form layout='inline'>
          <a-row :gutter='48'>

            <a-col :md='8' :sm='24'>

              <a-form-item label='订单编号' prop='orderNo'>

                <a-input v-model='queryParam.orderNo' placeholder='请输入订单编号'
                         allow-clear />
              </a-form-item>
            </a-col>

            <a-col :md='8' :sm='24'>

              <a-form-item label='用户id' prop='userId'>

                <a-input v-model='queryParam.userId' placeholder='请输入用户id'
                         allow-clear />
              </a-form-item>
            </a-col>
            <template v-if='advanced'>

              <a-col :md='8' :sm='24'>

                <a-form-item label='套餐id' prop='comboId'>

                  <a-input v-model='queryParam.comboId' placeholder='请输入套餐id'
                           allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md='8' :sm='24'>

                <a-form-item label='充值金额' prop='rechargeMoney'>

                  <a-input v-model='queryParam.rechargeMoney' placeholder='请输入充值金额'
                           allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md='8' :sm='24'>

                <a-form-item label='付款编号' prop='paymentNo'>

                  <a-input v-model='queryParam.paymentNo' placeholder='请输入付款编号'
                           allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md='8' :sm='24'>

                <a-form-item label='第三方订单号' prop='outTradeNo'>

                  <a-input v-model='queryParam.outTradeNo' placeholder='请输入第三方订单号'
                           allow-clear />
                </a-form-item>
              </a-col>

              <a-col :md='8' :sm='24'>

                <a-form-item label='订单付款时间' prop='payTime'>

                  <a-date-picker style='width: 100%' v-model='queryParam.payTime'
                                 format='YYYY-MM-DD HH:mm:ss' allow-clear />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md='!advanced && 8 || 24' :sm='24'>
              <span class='table-page-search-submitButtons'
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type='primary' @click='handleQuery'><a-icon type='search' />查询</a-button>
                <a-button style='margin-left: 8px' @click='resetQuery'><a-icon type='redo' />重置</a-button>
                    <a @click='toggleAdvanced' style='margin-left: 8px'>
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class='table-operations'>
        <a-button type='primary' @click='$refs.createForm.handleAdd()'
                  v-hasPermi="['vip:combo/order:add']">
          <a-icon type='plus' />
          新增
        </a-button>
        <a-button type='primary' :disabled='single' @click='$refs.createForm.handleUpdate(undefined, ids)'
                  v-hasPermi="['vip:combo/order:edit']">
          <a-icon type='edit' />
          修改
        </a-button>
        <a-button type='danger' :disabled='multiple' @click='handleDelete'
                  v-hasPermi="['vip:combo/order:remove']">
          <a-icon type='delete' />
          删除
        </a-button>
        <a-button type='primary' @click='handleExport' v-hasPermi="['vip:combo/order:export']">
          <a-icon type='download' />
          导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync='tableSize'
          v-model='columns'
          :refresh-loading='loading'
          @refresh='getList' />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref='createForm'
        @ok='getList'
      />
      <!-- 数据展示 -->
      <a-table
        :loading='loading'
        :size='tableSize'
        rowKey='id'
        :columns='columns'
        :data-source='list'
        :row-selection='{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }'
        :pagination='false'
        :bordered='tableBordered'
      >
                <span slot='payTime' slot-scope='text, record'>
          {{ parseTime(record.payTime) }}
        </span>
        <span slot='createTime' slot-scope='text, record'>
          {{ parseTime(record.createTime) }}
        </span>
        <span slot='operation' slot-scope='text, record'>
  <a-divider type='vertical' v-hasPermi="['vip:combo/order:edit']" />
          <a @click='$refs.createForm.handleUpdate(record, undefined)'
             v-hasPermi="['vip:combo/order:edit']">
            <a-icon type='edit' />修改
          </a>
          <a-divider type='vertical' v-hasPermi="['vip:combo/order:remove']" />
          <a @click='handleDelete(record)' v-hasPermi="['vip:combo/order:remove']">
            <a-icon type='delete' />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class='ant-table-pagination'
        show-size-changer
        show-quick-jumper
        :current='queryParam.pageNum'
        :total='total'
        :page-size='queryParam.pageSize'
        :showTotal='total => `共 ${total} 条`'
        @showSizeChange='onShowSizeChange'
        @change='changeSize'
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageComboOrder, listComboOrder, delComboOrder } from '@/api/vip/comboOrder'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ComboOrder',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        orderNo: null,
        userId: null,
        comboId: null,
        rechargeMoney: null,
        paymentType: null,
        paymentNo: null,
        outTradeNo: null,
        orderStatus: null,
        payTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '主键ID',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单编号',
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户id',
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '套餐id',
          dataIndex: 'comboId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '充值金额',
          dataIndex: 'rechargeMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '支付类型 1-微信 2-支付宝',
          dataIndex: 'paymentType',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '付款编号',
          dataIndex: 'paymentNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '第三方订单号',
          dataIndex: 'outTradeNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单状态1待付款 2已完成 3已关闭',
          dataIndex: 'orderStatus',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '订单付款时间',
          dataIndex: 'payTime',
          scopedSlots: { customRender: 'payTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询用户会员套餐订单列表 */
    getList() {
      this.loading = true
      pageComboOrder(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        orderNo: undefined,
        userId: undefined,
        comboId: undefined,
        rechargeMoney: undefined,
        paymentType: undefined,
        paymentNo: undefined,
        outTradeNo: undefined,
        orderStatus: undefined,
        payTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delComboOrder(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('vip/vip-combo-order/export', {
            ...that.queryParam
          }, `用户会员套餐订单_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
